var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AppSettings } from 'app/app.settings';
import { BehaviorSubject, Subject } from 'rxjs';
import { CommonRequestService } from './common-request.service';
import { UserService } from './user.service';
import * as i0 from "@angular/core";
import * as i1 from "./common-request.service";
import * as i2 from "./user.service";
var A3iService = /** @class */ (function () {
    // = '_id'; // internal id col
    function A3iService(requestService, userService) {
        this.requestService = requestService;
        this.userService = userService;
        this.parseSubject = new Subject();
        this.saveParseSubject = new Subject();
        this.commitSubject = new Subject();
        this.clearEditsSubject = new Subject();
        this.parseDisableBS = new BehaviorSubject({
            disabled: true
        });
        this.saveParseDisableBS = new BehaviorSubject({
            disabled: true
        });
        this.commitDisableBS = new BehaviorSubject({
            disabled: true
        });
        this.selectedRecordA3iBS = new BehaviorSubject({
            record: null
        });
        this.a3iEditColumnsBS = new BehaviorSubject({
            columns: []
        });
    }
    A3iService.prototype.parseAddress = function (addresses, stateCode, parseOnly) {
        return __awaiter(this, void 0, void 0, function () {
            var apiKey;
            var _this = this;
            return __generator(this, function (_a) {
                apiKey = this.userService.getA3iApiKey();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var url = AppSettings.serviceRootUrl + 'a3i/parseGeneral';
                        var body = {
                            addresses: JSON.stringify(addresses)
                        };
                        if (stateCode) {
                            body.stateCode = stateCode;
                        }
                        if (parseOnly) {
                            body.parseOnly = true;
                        }
                        var httpOptions = {
                            headers: { 'Authorization': apiKey }
                        };
                        // const httpOptions = {
                        // 	headers: new HttpHeaders({
                        // 		Authorization: apiKey
                        // 	})
                        // }
                        console.log('parse Address start to call');
                        _this.requestService.requestPost(url, body, function (rsp) {
                            resolve(rsp);
                            console.log(rsp);
                        }, function (err) { return reject(err); }, null, httpOptions);
                    })];
            });
        });
    };
    A3iService.prototype.updateA3iParseResult = function (layerId, a3iOutputWId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/a3iParseResult';
            var body = {
                // userSubscriptionId: this.userService.getUserInfo().userSubId,
                layerId: layerId,
                a3iOutputWId: JSON.stringify(a3iOutputWId)
            };
            _this.requestService.requestPut(url, body, function (rsp) { return resolve(rsp); }, function (err) { return reject(err); });
        });
    };
    A3iService.prototype.updateNenaPartsByA3i = function (layerId, ids) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/nenaPartsByA3i';
            var body = {
                userSubscriptionId: _this.userService.getUserInfo().userSubId,
                layerId: layerId,
                ids: JSON.stringify(ids)
            };
            _this.requestService.requestPut(url, body, function (rsp) { return resolve(rsp); }, function (err) { return reject(err); });
        });
    };
    A3iService.prototype.getRclByRcl = function (layerId, rclGrdId, model) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var url = AppSettings.serviceRootUrl + 'azgiv/rclByRcl';
                        var params = {
                            layerId: layerId,
                            rclGrdId: rclGrdId
                        };
                        if (model) {
                            params.model = model;
                        }
                        _this.requestService.requestGet(url, {
                            params: params
                        }, function (rsp) {
                            var ids = [];
                            rsp.data.forEach(function (i) { return ids.push(i.grd_globalid); });
                            resolve(ids);
                        }, function (err) { return reject(err); });
                    })];
            });
        });
    };
    A3iService.prototype.getLstStandardCols = function (standardSchema) {
        return standardSchema.filter(function (c) { return c.colName.toLowerCase().startsWith('lst_'); });
    };
    A3iService.prototype.getStStandardCols = function (standardSchema) {
        return standardSchema.filter(function (c) { return c.colName.toLowerCase().startsWith('st_'); });
    };
    A3iService.prototype.combinePartsToAddress = function (standardCols, prefix, rec) {
        var parts = [];
        standardCols.forEach(function (c) {
            var part = rec[prefix + "_" + c.colName.toLowerCase()];
            if (part) {
                parts.push(part.trim());
            }
        });
        var addr = parts.join(' ').trim();
        return addr;
    };
    A3iService.prototype.getRecordId = function (rec) {
        return rec[this.uniqueIdCol];
    };
    A3iService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function A3iService_Factory() { return new A3iService(i0.ɵɵinject(i1.CommonRequestService), i0.ɵɵinject(i2.UserService)); }, token: A3iService, providedIn: "root" });
    return A3iService;
}());
export { A3iService };
